import moment from 'moment';
import { css } from 'styled-components';

import Switch from '@components/Common/Switch';
import PanelOptionMixin from '../mixin';
import { ComponentWrapper } from '../dateFilter/styles';
import { GRAY } from '@/styles/common.styled';

const today = moment().format('YYYY-MM-DD');

export const Forecast = {
    name: 'PanelForecastOption',
    mixins: [PanelOptionMixin],
    props: {
        forecastEnabled: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        const { forecastEnabled } = this;
        return (
            <ComponentWrapper
                isDisabled={false}
                customStyle={css`
                    padding: 16px 16px 22px 16px;
                    margin-bottom: -10px !important;

                    transform: translate3d(0, -25px, 0);
                    border-top: none;

                    z-index: 1;

                    & .top-wrapper {
                        background: white;
                        height: 50px;
                        border: 1px solid ${GRAY(30)};
                        border-radius: 2px;
                        padding: 0 16px;
                    }

                    & .forecast-guide-text {
                        margin: 16px 0 0 0;
                        padding: 0 0 0 20px;

                        font-size: 12px;
                        font-weight: 400;
                        color: ${GRAY(40)};

                        & li {
                            list-style-type: disc;
                            line-height: 18px;
                        }
                    }
                `}
            >
                <div class="top-wrapper">
                    <div class="title">
                        <h1>{this.$t('WIDGET.widget.goal.forecast')}</h1>
                    </div>

                    <Switch
                        value={forecastEnabled}
                        disabled={false}
                        type="big"
                        onClick={() => {
                            // TODO: can turn on forecast on/off always
                            // const flag =
                            //     isDateFilterValidForForecast &&
                            //     !forecastEnabled;

                            this.$emit('update', !forecastEnabled);
                        }}
                    />
                </div>

                <ul class={'forecast-guide-text'}>
                    <li>
                        {this.$t(
                            'WIDGET.widget.goal.forecast_condition_period',
                            { today }
                        )}
                    </li>
                </ul>
            </ComponentWrapper>
        );
    },
};
